/**
 * Constantes de dominio compartidas (client-safe). Los esquemas zod y la capa
 * `runAgent` se agregan en el hito 5 bajo `./server`.
 */
export const AGENT_CODES = ['N1', 'N2', 'N3', 'N4', 'N5'];
export const PROVIDER_CODES = ['anthropic', 'openai', 'gemini', 'deepseek', 'glm'];
export const PRIORITIES = ['ALTA', 'MEDIA', 'BAJA'];
export const EDITION_STATUSES = ['draft', 'in_review', 'approved', 'sent'];
//# sourceMappingURL=agents.js.map